package ui.device.detail.preview.screen

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyGridScope
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.*
import org.jetbrains.compose.resources.StringResource
import ssoft.frontend.generated.resources.*
import tools.rememberString
import ui.device.detail.preview.DevicePreviewScope
import ui.device.detail.preview.DevicePreviewVM
import ui.device.detail.preview.ScreenshotDialog
import ui.widget.DialogState

@Composable
fun DevicePreviewScope.DeviceScreen04_Commands(nnvl: DevicePreviewScope.Wrapper) {
    val primaryC = MaterialTheme.colorScheme.primary
    val secondaryC = MaterialTheme.colorScheme.secondary
    val tertiaryC = MaterialTheme.colorScheme.tertiary
    val errorC = MaterialTheme.colorScheme.error

    val screenshotApplicationState = DialogState.remember()
    val screenshotDisplayState = DialogState.remember()
    ScreenshotDialog(screenshotDisplayState, login.id, nnvl.data.mac, 0)
    ScreenshotDialog(screenshotApplicationState, login.id, nnvl.data.mac, 1)

    LazyVerticalGrid(
        columns = GridCells.FixedSize(384.dp),
        horizontalArrangement = Arrangement.spacedBy(24.dp),
        verticalArrangement = Arrangement.spacedBy(16.dp),
        contentPadding = PaddingValues(24.dp),
        modifier = Modifier.fillMaxSize()
    ) {

        Header(Res.string.device_detail__cmd_header_preview)
        Item(
            icon = Svg.ScreenLand,
            iconTint = primaryC,
            title = Res.string.device_detail__cmd_preview_screen_title,
            message = Res.string.device_detail__cmd_preview_screen_msg,
            action = { screenshotDisplayState.show() }
        )
        Item(
            icon = Svg.Application_brackets_outline,
            iconTint = primaryC,
            title = Res.string.device_detail__cmd_preview_app_title,
            message = Res.string.device_detail__cmd_preview_app_msg,
            action = { screenshotApplicationState.show() }
        )

        Header(Res.string.device_detail__cmd_header_sync)
        Item(
            icon = Svg.Animation_play,
            iconTint = secondaryC,
            title = Res.string.device_detail__cmd_resend_playlist_title,
            message = Res.string.device_detail__cmd_resend_playlist_msg,
            action = { action(DevicePreviewVM.Action.DevAction.SendPlaylist) }
        )
        Item(
            icon = Svg.Square_rounded_badge_outline,
            iconTint = secondaryC,
            title = Res.string.device_detail__cmd_resend_apps_title,
            message = Res.string.device_detail__cmd_resend_apps_msg,
            action = { action(DevicePreviewVM.Action.DevAction.SendApps) }
        )
        Item(
            icon = Svg.Cog_play_outline,
            iconTint = secondaryC,
            title = Res.string.device_detail__cmd_resend_settings_title,
            message = Res.string.device_detail__cmd_resend_settings_msg,
            action = { action(DevicePreviewVM.Action.DevAction.SendConfig) }
        )

        Header(Res.string.device_detail__cmd_header_runtime)
        Item(
            icon = Svg.Refresh,
            iconTint = errorC,
            title = Res.string.device_detail__cmd_runtime_software_title,
            message = Res.string.device_detail__cmd_runtime_software_msg,
            action = { action(DevicePreviewVM.Action.DevAction.RestartApp) }
        )
        Item(
            icon = Svg.Power,
            iconTint = errorC,
            title = Res.string.device_detail__cmd_runtime_device_title,
            message = Res.string.device_detail__cmd_runtime_device_msg,
            action = { action(DevicePreviewVM.Action.DevAction.RebootDevice) }
        )

        Header(Res.string.device_detail__cmd_header_maintenance)
        Item(
            icon = Svg.Cellphone_arrow_down,
            iconTint = tertiaryC,
            title = Res.string.device_detail__cmd_maintenance_update_title,
            message = Res.string.device_detail__cmd_maintenance_update_msg,
            action = { action(DevicePreviewVM.Action.DevAction.Update) }
        )
        if (nnvl.isSuperAdmin) {
            Item(
                icon = Svg.Text_long,
                iconTint = tertiaryC,
                title = Res.string.device_detail__cmd_maintenance_console_title,
                message = Res.string.device_detail__cmd_maintenance_console_msg,
                action = { action(DevicePreviewVM.Action.DevAction.RemoteConsole) }
            )
        }
    }
}

private fun LazyGridScope.Item(
    icon: ImageVector,
    iconTint: Color,
    title: StringResource,
    message: StringResource,
    action: () -> Unit
) {
    item {
        Card(
            onClick = action,
            colors = CardDefaults.cardColors(
                containerColor = MaterialTheme.colorScheme.surfaceContainer
            )
        ) {
            Row(
                modifier = Modifier.padding(16.dp),
                horizontalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                Icon(
                    imageVector = icon,
                    tint = iconTint,
                    contentDescription = null,
                    modifier = Modifier
                        .background(
                            color = MaterialTheme.colorScheme.surfaceContainerLow,
                            shape = CardDefaults.shape
                        )
                        .padding(8.dp)
                )
                Column {
                    Text(
                        text = title.rememberString(),
                        style = MaterialTheme.typography.titleMedium
                    )
                    Text(
                        text = message.rememberString(),
                        style = MaterialTheme.typography.bodyMedium,
                        modifier = Modifier.alpha(0.6F),
                        minLines = 2
                    )
                }
            }
        }
    }
}

private fun LazyGridScope.Header(label: StringResource) {
    item(span = { GridItemSpan(maxLineSpan) }) {
        Text(
            text = label.rememberString(),
            style = MaterialTheme.typography.titleMedium,
            modifier = Modifier.alpha(0.9F)
        )
    }
}